// src/styles/tokens/spacing.tsx
var n = {
  "4xs": 2,
  "3xs": 4,
  "2xs": 6,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  "2xl": 40,
  "3xl": 48,
  "4xl": 56,
  "5xl": 64,
  "6xl": 72,
  "7xl": 80,
  "8xl": 96,
  "9xl": 112,
  "10xl": 128,
  "11xl": 160
};
var Spacing = {
  "4xs": n["4xs"],
  "3xs": n["3xs"],
  "2xs": n["2xs"],
  xs: n.xs,
  sm: n.sm,
  md: n.md,
  lg: n.lg,
  xl: n.xl,
  "2xl": n["2xl"],
  "3xl": n["3xl"],
  "4xl": n["4xl"],
  "5xl": n["5xl"],
  "6xl": n["6xl"],
  "7xl": n["7xl"],
  "8xl": n["8xl"],
  "9xl": n["9xl"],
  "10xl": n["10xl"],
  "11xl": n["11xl"],
  px: {
    "4xs": `${n["4xs"]}px`,
    "3xs": `${n["3xs"]}px`,
    "2xs": `${n["2xs"]}px`,
    xs: `${n.xs}px`,
    sm: `${n.sm}px`,
    md: `${n.md}px`,
    lg: `${n.lg}px`,
    xl: `${n.xl}px`,
    "2xl": `${n["2xl"]}px`,
    "3xl": `${n["3xl"]}px`,
    "4xl": `${n["4xl"]}px`,
    "5xl": `${n["5xl"]}px`,
    "6xl": `${n["6xl"]}px`,
    "7xl": `${n["7xl"]}px`,
    "8xl": `${n["8xl"]}px`,
    "9xl": `${n["9xl"]}px`,
    "10xl": `${n["10xl"]}px`,
    "11xl": `${n["11xl"]}px`
  }
};

export {
  Spacing
};
